import { useStateXSetter } from '@cloudio-saas/statex';
import { Platform } from 'componentregistry';
import { pageAtom } from 'designer/atoms';
import { usePending } from 'platform/PlatformHooks';
import { useEffect } from 'react';
import PageContainer from 'root/PageContainer';
import getPageJson from './CustomTemplatesPageJson';
import WaveDots from 'utils/WaveDots';

export default function CustomTemplates({
  appUid,
  platform,
  width,
  height,
  ds,
}: {
  appUid: string;
  platform: Platform;
  width: number;
  height: number;
  ds: string;
}) {
  const set = useStateXSetter();
  const pageId = 'custom-templates';
  const [pending, setPending] = usePending();

  useEffect(() => {
    platform.startAsyncTransition(async () => {
      set(pageAtom, getPageJson(ds), {
        params: {
          appUid,
          pageId,
        },
      });
    }, setPending);
  }, [appUid, ds, pageId, platform, set, setPending]);

  const content = (
    <PageContainer
      key="ds-custom-templates"
      width={width - 10}
      height={height - 65}
      appUid={appUid}
      pageId={pageId}
      roleUid={platform.roleUid}
      paramString=""
    />
  );
  return pending ? <WaveDots active /> : content;
}
